import React from "react";
import { graphql, Link, PageProps } from "gatsby";
import Layout from "../components/Layout";
import ArticleWidget from "../components/ArticleWidget";
import { RichText } from "prismic-reactjs";
import linkResolver from "../utils/linkResolver";
import styled from "styled-components";
import SEO from "../components/seo";


const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

const PageButton = styled(Link)`
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primary};
    //color:${props => props.theme.colors.primary};
  color: white;
  padding: 5px 10px;

  &:hover {
    color: ${props => props.theme.colors.secondary};

  }

`;

const Page = styled.div`
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primary};
    //color:${props => props.theme.colors.primary};
  color: white;
  padding: 5px 10px;
`;

const PageButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;

  * {
    margin: 15px;
  }
`;

export const query = graphql`
    query BlogIndex($first: Int = 5, $after: String, $before: String) {
        prismic {
            allO_mnies {
                edges {
                    node {
                        text
                        image
                    }
                }
            }
            allArticles(sortBy: meta_firstPublicationDate_DESC, first: $first, after: $after, before: $before) {
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    node {
                        title
                        image
                        imageSharp {
                            childImageSharp {
                                fluid(srcSetBreakpoints: [480]) {
                                    sizes
                                    src
                                    srcSet
                                    base64
                                    presentationHeight
                                    presentationWidth
                                    aspectRatio
                                }
                                resize {
                                    src
                                }
                            }
                        }
                        content
                        description
                        _meta {
                            type
                            tags
                            uid
                            firstPublicationDate
                            id
                        }
                        category {
                            ... on PRISMIC_Category {
                                name
                            }
                        }
                    }
                }
            }
        }
    }
`;

interface IndexPageProps extends PageProps {
    data: GatsbyTypes.BlogIndexQuery;
}

const ArticleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  & > * {
    margin-bottom: 50px;
  }
`;

const IndexPage: React.FunctionComponent<IndexPageProps> = ({ data, pathContext, pageContext }) => {

    const desc = data.prismic.allO_mnies.edges && RichText.asText(data.prismic.allO_mnies.edges[0]?.node.text);
    const image = data.prismic.allO_mnies.edges && data.prismic.allO_mnies.edges[0]?.node.image.url;

    return (
        <Layout>
            <SEO title="Blog" description={desc} image={image}/>
            <Wrapper>

                <ArticleWrapper>
                    {!!data.prismic.allArticles.edges &&
                    data.prismic.allArticles.edges.map(article => {
                        if (!article) return null;
                        return (
                            <ArticleWidget
                                key={article.node._meta.uid}
                                title={RichText.asText(article.node.title)}
                                imageFluid={article.node.imageSharp?.childImageSharp?.fluid}
                                description={RichText.asText(article.node.description)}
                                link={linkResolver(article.node._meta)}
                                tags={article.node._meta.tags}
                                date={article.node._meta.firstPublicationDate}
                                category={
                                    ((article.node
                                        .category as unknown) as GatsbyTypes.PRISMIC_Category)?.name
                                }
                            />
                        );
                    })}
                </ArticleWrapper>

                {data.prismic.allArticles.pageInfo.hasNextPage &&
                <PageButtonsWrapper>
                    <Page>1</Page>
                    <PageButton to={`/strona/2`}>Następna strona</PageButton>
                </PageButtonsWrapper>
                }
            </Wrapper>
        </Layout>
    );
};

export default IndexPage;
